import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

type CalendarUnit = 'day' | 'week' | 'month'

export const calendarDay = (value: string) => value.slice(0, 10)

export const todayCalendarDay = () => dayjs().format('YYYY-MM-DD')

export const shiftCalendarDate = (value: string, amount: number, unit: CalendarUnit) =>
  dayjs.utc(value).add(amount, unit).format('YYYY-MM-DD')
